module.exports = __webpack_public_path__ + "static/media/Computer.0f02afd1.png";